export interface Post {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  zoneId: string;
  author: string;
  date: string;
  readCount: number;
  tags: string[];
  paragraphs: string[];
  featured: boolean;
  hot: boolean;
}

export const posts: Post[] = [
  {
    id: "p1",
    title: "《长夜行》大结局名场面复盘：三处伏笔早就埋好了",
    excerpt:
      "大结局上线一晚就冲上讨论区榜首。重看一遍会发现，那些让人拍腿的转折，其实从第五集就已经给出了暗示。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20an%20antique%20oil%20lamp%20glowing%20on%20a%20dark%20wooden%20table%20with%20scattered%20script%20pages%2C%20moody%20amber%20light%2C%20mysterious%20ancient%20drama%20atmosphere%2C%20cream%20and%20vermilion%20accents%2C%20magazine%20photography&width=1200&height=800&seq=post-longnight-91&orientation=landscape",
    zoneId: "z1",
    author: "编辑 林七",
    date: "2026-09-09",
    readCount: 68400,
    tags: ["名场面", "伏笔", "大结局"],
    paragraphs: [
      "《长夜行》收官之后，讨论区里出现最多的一句话是「回头看全是伏笔」。这部剧最聪明的地方，不在于结局有多反转，而在于它把线索藏在了很日常的对话里，观众第一遍看过去几乎不会留意。",
      "第一处伏笔是那盏反复出现的旧油灯。它一共在六个场景里亮过，每次出现时人物的站位都不一样。到了大结局你会发现，灯摆在桌上还是窗前，其实对应着角色当时的选择处境，导演用道具位置替代了台词交代。",
      "第二处是配角的重复口癖。这个角色从第八集开始换了口头禅，观众大多当成笑点，实际上那句新口癖是他身份转变的信号。编剧没有用旁白点破，而是让同一个动作在不同阶段产生完全不同的意味。",
      "第三处藏在片头。片头动画里有几帧画面只出现不到一秒，剪辑上看起来像是随便过的转场，但对应到正片，那几帧恰好是三个关键地点。把片头逐帧暂停，整条线索链就清清楚楚了。",
      "这也是这部剧值得二刷的原因：不靠强行解释，而是相信观众会回来找答案。而好的合集整理，就是把散落在各处的线索重新摆到一条线上，看不看得懂由观众自己决定。",
    ],
    featured: true,
    hot: true,
  },
  {
    id: "p2",
    title: "这一季综艺的名梗盘点，留到年底还能笑出声",
    excerpt:
      "从开播到现在，节目里能单独拎出来的桥段已经攒了十几个。我们按出现顺序整理了一份，顺手标注了每个梗的用法。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20editorial%20flat%20lay%20of%20party%20poppers%20and%20laughter%20emoji%20props%20on%20warm%20cream%20paper%2C%20playful%20variety%20show%20energy%2C%20bright%20soft%20studio%20light%2C%20magazine%20style%20still%20life&width=1200&height=800&seq=post-variety-memes-91&orientation=landscape",
    zoneId: "z2",
    author: "编辑 阿圆",
    date: "2026-09-08",
    readCount: 52300,
    tags: ["名梗", "盘点", "用法"],
    paragraphs: [
      "一档综艺能不能留下记忆点，很多时候不看游戏设计得多复杂，而看嘉宾之间的反应有没有被完整捕捉下来。这一季的高光时刻，几乎都来自没有排练过的意外反应。",
      "排在第一位的名梗源于一次道具故障。原本设计好的环节因为机关卡住而中断，嘉宾没有停下来等，而是顺势把故障编进了对话里。这段后来被节目组原样保留，成了全季播放量最高的一段。",
      "第二个梗来自后期的字幕。剪辑把某个口误单独放大，并且配了一个非常克制的音效，反而制造出更强的喜剧效果。这说明梗不一定要靠嘉宾抖出来，后期节奏同样在参与创作。",
      "整理这份名单时我们刻意标注了每个梗适用的场景：有的适合朋友聚会时抛出来，有的只适合在弹幕里刷。梗离开了语境会失效，把它用在对的地方，才算真的看过这档节目。",
    ],
    featured: false,
    hot: true,
  },
  {
    id: "p3",
    title: "剧组道具间探班：一件戏服从设计到成衣要走多少步",
    excerpt:
      "我们跟着造型组走了一遍完整流程。从人物小传开始，到最终上镜确认，一件主要角色的戏服至少要经过九道工序。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20traditional%20costume%20fabric%20swatches%2C%20measuring%20tape%20and%20tailoring%20scissors%20on%20a%20wooden%20workbench%2C%20craft%20and%20costume%20making%20concept%2C%20soft%20natural%20light%2C%20cream%20palette&width=1200&height=800&seq=post-costume-91&orientation=landscape",
    zoneId: "z3",
    author: "编辑 周野",
    date: "2026-09-06",
    readCount: 31800,
    tags: ["道具", "造型", "探班"],
    paragraphs: [
      "走进道具间之前，我原本以为戏服是按主角、配角分等级的。造型指导摇头说，他们真正的分法只有一种：这个人物在故事里会不会「变」，会变的人才值得多花钱。",
      "流程的第一步不是画图，而是读人物小传。造型组会先把角色从出场到结束的处境列成时间轴，标注他什么时候有钱、什么时候落魄、什么时候开始伪装。衣服要跟着这条线走，而不是跟着演员的喜好走。",
      "第二步才是找面料。同一块布料要在不同灯光下反复比对，因为镜头里的颜色和肉眼看到的并不一样。有一件外套因为暖光下偏黄，被退回改了三次，最后还是换了材质才通过。",
      "一件主要戏服从设计到成衣，通常要经过形制考据、面料测试、打版、试身、做旧、上镜确认等九道工序。真正花时间的不是缝合，而是每道工序之间的来回确认。",
      "造型指导说，观众记住的往往不是衣服本身，而是「他穿着这件衣服做了什么」。所以道具间的所有努力，本质上都是在给表演让路，让观众不出戏，这就够了。",
    ],
    featured: false,
    hot: false,
  },
  {
    id: "p4",
    title: "舞台直拍为什么比正片更上头？从机位说起",
    excerpt:
      "同一段表演，直拍版本的播放量经常是正片的几倍。这不只是粉丝滤镜，机位、景别和收音方式都在悄悄影响你的感受。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20concert%20stage%20photograph%20with%20warm%20amber%20spotlights%20and%20a%20microphone%20stand%20silhouette%20against%20glowing%20haze%2C%20bokeh%20crowd%2C%20editorial%20music%20magazine%20style%2C%20gold%20and%20cream%20tones&width=1200&height=800&seq=post-stage-91&orientation=landscape",
    zoneId: "z4",
    author: "编辑 陈屿",
    date: "2026-09-07",
    readCount: 28900,
    tags: ["直拍", "机位", "现场"],
    paragraphs: [
      "先说结论：直拍比正片上头，很大一部分原因在于它没有剪辑。正片需要在多个机位之间切换来交代全场，而直拍从头到尾跟着一个人，观众的情绪不会被打断。",
      "第二是景别。正片为了兼顾舞台调度，常用中景和全景，人物在画面里只占一小块。直拍则大量使用近景，观众能看到呼吸、手部动作和表情变化，注意力自然更集中。",
      "第三是收音。正片通常以调音台输出为主，声音干净但偏「平」。直拍多用现场收音，会保留观众的欢呼、脚步和混响，这些瑕疵恰好构成了现场感，让人觉得「我也在场」。",
      "当然直拍也有代价。它放弃了编舞的队形变化和走位设计，如果你关注的是整体舞台效果，正片依然是更好的选择。看哪一种，本质上是看你想要沉浸感还是完整感。",
    ],
    featured: false,
    hot: false,
  },
  {
    id: "p5",
    title: "本周网络热词速览：这些词正在悄悄扩散",
    excerpt:
      "我们记录了一周内出现了明显增长的说法，并标出了出处和常用语境。有些词看着热闹，其实已经开始退潮了。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20still%20life%20of%20a%20glowing%20smartphone%20screen%2C%20speech%20bubble%20cards%20and%20trend%20arrow%20props%20on%20warm%20off%20white%20desk%2C%20internet%20culture%20concept%2C%20soft%20daylight%2C%20clean%20magazine%20composition&width=1200&height=800&seq=post-trending-91&orientation=landscape",
    zoneId: "z5",
    author: "编辑 林七",
    date: "2026-09-09",
    readCount: 61200,
    tags: ["热词", "出处", "扩散"],
    paragraphs: [
      "热词的生命周期比大多数人的想象要短。我们统计了近三十天的数据，一个从短视频走红的说法，平均在第十一天达到峰值，第二十天开始明显回落。",
      "这一周增长最快的是两个口语化说法，它们共同点是都能套进固定的句式，使用时不需要理解具体含义。这种「低门槛可复制」正是热词扩散的核心条件。",
      "反之，一些看起来更巧妙的表达反而没能扩散。因为它们对语境要求太高，脱离了原始场景就不成立。好记和好用，往往只能占一样。",
      "整理这份速览的意义，不只是让你跟上话题。看清一个词从哪里来、为什么会退潮，比单纯知道它是什么意思更有用，也能帮你判断下一个词值不值得学。",
    ],
    featured: false,
    hot: true,
  },
  {
    id: "p6",
    title: "收视与热度双榜解读：口碑和流量这次对上了吗",
    excerpt:
      "本期榜单出现了一个不太常见的现象：收视前三和话题热度前三几乎完全重合。这种一致到底说明什么？",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20still%20life%20of%20a%20bar%20chart%20printed%20on%20cream%20paper%20with%20a%20golden%20pen%20and%20small%20trophy%20on%20a%20warm%20wooden%20desk%2C%20ranking%20and%20ratings%20concept%2C%20soft%20studio%20lighting%2C%20premium%20magazine%20photography&width=1200&height=800&seq=post-chart-91&orientation=landscape",
    zoneId: "z6",
    author: "编辑 周野",
    date: "2026-09-05",
    readCount: 25700,
    tags: ["收视", "热度", "解读"],
    paragraphs: [
      "通常情况下，收视和网络热度会有偏差：有的内容电视机前观众多，但年轻人讨论得少；有的正好相反。这一期两份榜单高度重合，是一个值得留意的信号。",
      "第一个原因在排播。本期头部内容都集中在周末晚间，天然的观看时段优势被放大，两个渠道的观众重叠度自然变高。",
      "第二个原因在题材。这几部作品都选择了容易引发讨论的现实向话题，观看时不需要额外知识背景，讨论门槛低，于是电视端的观众也愿意到网上说两句。",
      "需要提醒的是，榜单重合并不等于内容质量更高，它更多反映的是「传播效率」。一份榜单能回答的是多少人看了，回答不了的是看完之后留下了什么。",
    ],
    featured: false,
    hot: false,
  },
  {
    id: "p7",
    title: "古装剧里的四季取景，原来是这样调出来的",
    excerpt:
      "很多看起来是深秋的戏，其实是在初夏拍的。季节感靠的不只是实景，还有置景、调色和演员的状态管理。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20landscape%20of%20a%20misty%20ancient%20Chinese%20courtyard%20in%20autumn%20with%20red%20maple%20leaves%2C%20soft%20golden%20light%2C%20atmospheric%20period%20drama%20scenery%2C%20magazine%20feature%20photography&width=1200&height=800&seq=post-season-91&orientation=landscape",
    zoneId: "z1",
    author: "编辑 陈屿",
    date: "2026-09-04",
    readCount: 19400,
    tags: ["取景", "调色", "置景"],
    paragraphs: [
      "影视作品的拍摄顺序和故事顺序完全不同。为了迁就场地档期和演员行程，同一场戏可能被拆到两个季节拍摄，最终呈现在观众面前的四季，是后期重新拼出来的。",
      "最直接的手段是置景。树叶可以用绢布逐片绑上去，地面的落叶其实是回收清洗后再铺的。只要镜头不拍到远景，观众很难察觉季节被人为调整过。",
      "第二层是调色。同一批素材，只要把中间调往暖里推一点，再压一压绿色饱和度，初夏的画面就能读出深秋的味道。关键在于全片色温保持一致，否则切换镜头时会明显穿帮。",
      "还有一层常被忽略：演员的状态。厚重的冬衣在高温下拍摄，演员的呼吸和出汗都会影响画面。一些剧组会刻意调整拍摄时段，把这类戏安排在清晨完成。",
      "所以当你觉得某个场景的季节感特别准，背后往往是置景、调色、表演三者一起在起作用，而不是恰好赶上了一个好天气。",
    ],
    featured: false,
    hot: false,
  },
  {
    id: "p8",
    title: "嘉宾化学反应是怎么来的？综艺剪辑的取舍逻辑",
    excerpt:
      "观众觉得「这几位特别有火花」，但素材可能有几百小时。剪辑师做的，是从大量平淡里挑出那几分钟的真实反应。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20editorial%20still%20life%20of%20empty%20director%20chairs%20side%20by%20side%20with%20a%20clapperboard%20on%20warm%20cream%20background%2C%20talk%20show%20chemistry%20concept%2C%20soft%20studio%20light%2C%20magazine%20style%20composition&width=1200&height=800&seq=post-guest-91&orientation=landscape",
    zoneId: "z2",
    author: "编辑 阿圆",
    date: "2026-09-03",
    readCount: 22100,
    tags: ["嘉宾", "剪辑", "化学反应"],
    paragraphs: [
      "一档棚内综艺单期素材通常在两百到四百小时之间，最终成片只有一个多小时。也就是说，观众看到的每一分钟，背后都经过了大量取舍。",
      "剪辑师首先要回答一个问题：这一段能不能体现人物关系。同样是笑，如果笑完没有回应，就属于无效素材；如果笑完后有人接话并且产生了新的反应，这段就值得留下。",
      "第二个判断标准是节奏。连续三段情绪都拉满，观众会疲劳。有经验的剪辑会刻意在中间插入一段相对平静的过渡，让后面的高潮显得更有力。",
      "最后才是保留「真实」。所谓化学反应并不是剪辑制造出来的，它本来就在录制现场发生过，剪辑的作用只是不让它被淹没。这也是为什么有些组合怎么剪都好看，有些组合给了时长也不出效果。",
    ],
    featured: false,
    hot: false,
  },
];